import Vue from 'vue';
import wlAlert from './index.vue';

let wlAlertConstructor = Vue.extend(wlAlert);

let theWlAlert = function (option) {
  return new Promise((res, rej) => { //promise封装，ok执行resolve
    let wlAlertDom = new wlAlertConstructor({   
      el: document.createElement('div')
    })
    document.body.appendChild(wlAlertDom.$el);  //new一个对象，然后插入body里面

    wlAlertDom.option = option;   //为了使组件的扩展性更强，这个采用对象的方式传入，所有的字段都可以根据需求自定义
    wlAlertDom.ok = function () {
      res()
      wlAlertDom.isShow = false
    }
  })
}

//暴露出去，挂载到vue的原型上 
export default theWlAlert;


// WEBPACK FOOTER //
// ./src/components/wl-alert/index.js